export default {

    state: {
      agendaProcurador: null
    },
  
    mutations: {
        setAgendaProcurador(state, payload) {
          state.agendaProcurador = payload;
        }
    },
  
    getters: {
      getAgendaProcurador(state) {
        return state.agendaProcurador;
      }
    },

    actions: {
        setAgendaProcurador({commit}, agendaProcurador){
          commit('setAgendaProcurador', agendaProcurador);
        }
    },
    
  }